module.exports = __webpack_public_path__ + "static/media/img2.282bcb4d.png";